module.exports = __webpack_public_path__ + "img/info_icon.0ecf371c.svg";